module.exports = __webpack_public_path__ + "static/5.3_ancient_egypt-52dd82abd951603e6c5692af56516094.pdf";